import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";

export default class VendorShopifyCredentialsController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.bus = new ServiceBus();
		$ctrl.vendorId = options.vendorId;
		$ctrl.title = options.title || "Shopify Credentials";
	}
	$onInit() {
		const $ctrl = this;
	}
	updateCreds() {
		const $ctrl = this;
		$ctrl.bus.send("Shopify/UpdateCredentials", {
			VendorId: $ctrl.vendorId,
			StoreUrl: $ctrl.storeUrl,
			SecretKey: $ctrl.secretKey
		}).then(function(res) {

			$ctrl.$close();
		});
	}
  }
